'use client';

import type { ReactNode } from 'react';
import { LoginRenderer } from '../../ToolCallsRenderers/renderers/LoginRenderer';
import type { OutputRenderContext } from '../../tool-config-types';

export const renderLoginResult = (ctx: OutputRenderContext): ReactNode => {
  const { content, maxHeight } = ctx;
  return <LoginRenderer data={content} maxHeight={maxHeight} />;
};
